import memoize from "memoize-one";

import API from "../utils/api";
import { endpoints } from "../config";

export default class BdBeService {

  static requestAPI(query, request = {}, endpoint) {
    const { isQuerySearch } = query;
    const url = endpoint ? endpoint : isQuerySearch ? endpoints.bdBe : { url: `${endpoints.bdBe.url}`, auth: true }
    return API.request(url, request);
  }

  static cacheGet = memoize(this.requestAPI);

  static get(query, request, endpoint) {
    return this.cacheGet(query, request, endpoint);
  }
  static set(data, request = {}) {
    const { id, isReject, isSendEmail, rejectReason, userPANs } = data;
    const url = {
      url: isReject ? `${endpoints.reject10bdbeNonprofits.url}/${id}` : isSendEmail ?
        `${endpoints.sendEmail10bdbeNonprofits.url}`
        : `${endpoints.approve10bdbeNonprofits.url}/${id}`, auth: true
    }

    const payload = {
      filter: {
        ...data
      },
    };

    return API.request(url, {
      method: 'post', 
      data : payload
    });
  }

  static get10BESendEmailsList(query, params){
    return this.requestAPI(
      {query},
      {...params},
      {
        url: `${endpoints.emailsList.url}`,
        method: "GET",
        auth: true,
      }
    );
  }
}


